import {Input} from './';
import React, {PropTypes} from 'react';

export default function TextInput(props) {
  return <Input type="text" {...props} />;
}

TextInput.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  textFieldRef: PropTypes.func,
  value: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/TextInput.js